import { useDispatch, useSelector } from "react-redux";
import * as React from "react";
import { useEffect } from "react";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";
import { ModalNotification } from "@com.mgmtp.a12.widgets/widgets-core/lib/modal-notification/main/modal-notification.view";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group/main/button-group.view";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button/main/button.view";
import { Icon } from "@com.mgmtp.a12.widgets/widgets-core/lib/icon/main/icon.view";
import { Select } from "@com.mgmtp.a12.widgets/widgets-core/lib/input/select";

import { RESOURCE_KEYS } from "../../../localization";
import { fetchWrapper } from "../../../app/sagas/fetchSagaFactory";

import { changeZugehoerigkeit } from "../actions";

export function ChangeMembershipModal(props: View) {
	const { activityId } = props;

	const activity = useSelector(ActivitySelectors.activityById(activityId))!;

	const { key, client } = activity.descriptor;

	const dispatch = useDispatch();
	const { localizer } = React.useContext(LocalizerContext);

	const [zugehoerigkeit, setZugehoerigkeit] = React.useState<string | undefined>(client);

	const [zugehoerigkeiten, setZugehoerigkeiten] = React.useState<{ value: string; label: string }[]>([]);

	const onCancel = React.useCallback(() => {
		dispatch(ActivityActions.cancel({ activityId }));
	}, [dispatch, activityId]);

	const onConfirmClick = React.useCallback(() => {
		if (zugehoerigkeit === client) {
			return;
		}

		if (activity.descriptor.instance && activity.initiatingActivityId) {
			dispatch(
				changeZugehoerigkeit({
					instanceId: activity.descriptor.instance,
					activityId,
					overviewActivityId: activity.initiatingActivityId,
					zugehoerigkeit: zugehoerigkeit
				})
			);
		}
	}, [dispatch, activity, zugehoerigkeit, activityId]);

	useEffect(() => {
		let isMounted = true;

		async function loadMetadata() {
			try {
				const response = await fetchWrapper({
					relativeUrl: `/client?fvKey=${key}`,
					method: "GET"
				});
				if (!response.ok) {
					return;
				}
				const data = await response.json();
				if (!Array.isArray(data)) {
					return;
				}

				// State-Changes sollte nicht auf nicht gemountete Komponenten ausgeführt werden
				if (isMounted) {
					setZugehoerigkeiten(data.map(it => ({ value: it, label: it })));
				}
			} catch (e) {
				console.error(e);
			}
		}

		loadMetadata();

		return () => {
			isMounted = false;
		};
	}, []);

	return (
		<ModalNotification
			icon={<Icon>diversity_3</Icon>}
			title={localizer({ key: RESOURCE_KEYS.features.zugehoerigkeit.title })}
			enableCloseButton
			closeOnEsc
			closeOnOutsideClick
			focusOnOpen
			onClose={onCancel}
			id="zugehoerigkeit-modal"
			variant="warning"
			footer={
				<ButtonGroup alignment="right">
					<Button
						label={localizer({ key: RESOURCE_KEYS.features.zugehoerigkeit.cancel })}
						secondary
						onClick={onCancel}
					/>
					<Button
						label={localizer({ key: RESOURCE_KEYS.features.zugehoerigkeit.button })}
						destructive
						primary
						disabled={zugehoerigkeit === client}
						onClick={onConfirmClick}
					/>
				</ButtonGroup>
			}
		>
			<p>
				{localizer({
					key: RESOURCE_KEYS.features.zugehoerigkeit.info
				})}
			</p>

			<Select
				id={`view-${props.activityId}-zugehoerigkeit-modal`}
				label="Zugehörigkeiten"
				value={zugehoerigkeit}
				onValueChanged={e => {
					setZugehoerigkeit(e);
				}}
				items={zugehoerigkeiten}
			/>
		</ModalNotification>
	);
}
